import React, {Component} from 'react';
import {CardElement, injectStripe} from 'react-stripe-elements';
import LocaleStrings from 'Languages';

const createOptions = (fontSize, padding) => {
return {
  style: {
    base: {
      fontSize,
      color: '#424770',
      letterSpacing: '0.025em',
      fontFamily: 'Montserrat-Regular',
      '::placeholder': {
        color: '#aab7c4',
      },
      padding,
    },
    invalid: {
      color: '#9e2146',
    },
  },
};
};

const handleChange = (change) => {

};

const handleBlur = () => {

};

class CheckoutForm extends Component {
  constructor(props) {
    super(props);
    this.submit = this.submit.bind(this);
    this.state = {
      elementFontSize: window.innerWidth < 450 ? '13px' : '15px',
    };
    window.addEventListener('resize', () => {
      if (window.innerWidth < 450 && this.state.elementFontSize !== '13px') {
        this.setState({elementFontSize: '13px'});
      } else if (
        window.innerWidth >= 450 &&
        this.state.elementFontSize !== '15px'
      ) {
        this.setState({elementFontSize: '15px'});
      }
    });
  }

  submit = (ev) => {
    // We don't want to let default form submission happen here, which would refresh the page.
    var that=this;
    ev.preventDefault();
    this.props.stripe.createToken().then(({error,token}) => {
   
      if(error){
          that.props.onTokenReceived(null,error);
      }else{
        if(token)
          that.props.onTokenReceived(token,null);
      }
    });

    /*
    ,(status, response)=>{
        if (response.error) {
            this.reportError(response.error.message);
        } else { // No errors, submit the form.
          var token = response.id;
          if(token)
            this.props.onTokenReceived(token);
        }
    }
  );

    */
  }

  render() {
    var fontSize=this.state.elementFontSize;
    return (
      <div className="Checkout">
        <form onSubmit={this.submit} className="stripeform">
          <div style={{marginBottom:60}}>
            <label className="stripelabel">
              {LocaleStrings.publish_checkout_form_label_email}
              <input
                name="email"
                type="email"
                value={this.props.email}
                className="stripeinput"
                onChange={handleChange}
                readOnly
              />
            </label>
          </div>
          <div>
            <label className="stripelabel">
              {LocaleStrings.publish_checkout_form_label_card_details}
              <CardElement
              {...createOptions(fontSize)}
              onBlur={handleBlur}
              onChange={handleChange}
              hidePostalCode={true}/>
            </label>
          </div>
          <div>
            <button className="stripebutton" disabled={!this.props.stripe}>{`Pay $${this.props.amount/100}`}</button>
          </div>
        </form>
      </div>
    );
  }
}

export default injectStripe(CheckoutForm);
